import React from 'react';
import './Solutions.css';

const Solutions = () => {
  const benefits = [
    {
      icon: 'fas fa-piggy-bank',
      title: 'Tiết kiệm',
      highlight: '90%',
      description: 'Chi phí điện hàng tháng'
    },
    {
      icon: 'fas fa-shield-alt',
      title: 'Chế độ bảo hành',
      highlight: 'Vượt trội',
      description: 'Bảo hành lên đến 25 năm'
    },
    {
      icon: 'fas fa-clock',
      title: 'Thời gian thu hồi vốn',
      highlight: '3 – 5 năm',
      description: 'Đầu tư sinh lời bền vững'
    }
  ];

  const features = [
    {
      icon: 'fas fa-file-contract',
      title: 'Thủ tục pháp lý',
      description: 'Nhanh chóng, tuân thủ pháp luật'
    },
    {
      icon: 'fas fa-paint-brush',
      title: 'Thẩm mỹ',
      description: 'An toàn, đẹp mắt, phù hợp với mọi kiểu nhà'
    },
    {
      icon: 'fas fa-cogs',
      title: 'Hệ thống',
      description: 'Hiện đại, tuân thủ tiêu chuẩn an toàn'
    },
    {
      icon: 'fas fa-credit-card',
      title: 'Hỗ trợ trả góp',
      description: 'Hỗ trợ trả góp đến 80%'
    }
  ];

  const process = [
    {
      step: '01',
      title: 'Tư vấn miễn phí',
      description: 'Đội ngũ chuyên gia tư vấn giải pháp phù hợp với nhu cầu của bạn'
    },
    {
      step: '02',
      title: 'Khảo sát thực tế',
      description: 'Khảo sát vị trí lắp đặt, đánh giá hiệu quả và thiết kế hệ thống'
    },
    {
      step: '03',
      title: 'Báo giá chi tiết',
      description: 'Báo giá minh bạch, không phát sinh chi phí ẩn'
    },
    {
      step: '04',
      title: 'Thi công lắp đặt',
      description: 'Đội ngũ kỹ thuật chuyên nghiệp, thi công nhanh chóng, an toàn'
    },
    {
      step: '05',
      title: 'Nghiệm thu bàn giao',
      description: 'Nghiệm thu hệ thống, hướng dẫn sử dụng và bảo trì'
    },
    {
      step: '06',
      title: 'Bảo hành hậu mãi',
      description: 'Chế độ bảo hành dài hạn, hỗ trợ kỹ thuật 24/7'
    }
  ];

  return (
    <section id="solutions" className="solutions-section">
      {/* Benefits Section */}
      <div className="solutions-benefits">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <span className="section-tag">GIẢI PHÁP</span>
            <h2 className="section-title">
              GIẢI PHÁP LẮP ĐẶT ĐIỆN MẶT TRỜI
            </h2>
            <h3 className="section-subtitle-highlight">Thông Minh GNINE SOLAR</h3>
          </div>

          <div className="benefits-grid">
            {benefits.map((benefit, index) => (
              <div 
                key={index} 
                className="benefit-card"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="benefit-icon">
                  <i className={benefit.icon}></i>
                </div>
                <h4 className="benefit-title">{benefit.title}</h4>
                <div className="benefit-highlight">
                  lên đến <span>{benefit.highlight}</span>
                </div>
                <p className="benefit-description">{benefit.description}</p>
              </div>
            ))}
          </div>

          <div className="features-grid">
            {features.map((feature, index) => (
              <div 
                key={index} 
                className="feature-card"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="feature-icon">
                  <i className={feature.icon}></i>
                </div>
                <div className="feature-content">
                  <h4 className="feature-title">{feature.title}</h4>
                  <p className="feature-description">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Process Section */}
      <div className="solutions-process">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <span className="section-tag">QUY TRÌNH</span>
            <h2 className="section-title text-white">QUY TRÌNH LẮP ĐẶT</h2>
            <p className="section-description text-white-muted">
              Quy trình chuyên nghiệp, minh bạch từ tư vấn đến bàn giao
            </p>
          </div>

          <div className="process-timeline">
            {process.map((item, index) => (
              <div 
                key={index} 
                className="process-item"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="process-step">{item.step}</div>
                <div className="process-content">
                  <h4 className="process-title">{item.title}</h4>
                  <p className="process-description">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Solutions;